export function setLightMode() {
    // Всегда используем светлую тему, игнорируя cookies и настройки браузера
    const forcedLightMode = "light";
    if (typeof median !== "undefined") {
        // Используем JavaScript Bridge для установки светлой темы
        median.screen.setColorScheme(forcedLightMode);
    }
    else {
        // Устанавливаем атрибут для CSS
        document.documentElement.setAttribute("data-color-scheme-option", forcedLightMode);
    }
    // Всегда устанавливаем светлую тему
    document.documentElement.setAttribute("color-scheme", forcedLightMode);
}
export function initTheme() {
    // Инициализируем светлую тему при загрузке
    setLightMode();
    // Слушаем событие готовности Median библиотеки
    if (typeof window.median_library_ready === "function") {
        window.median_library_ready = function () {
            setLightMode();
        };
    }
}
